import styles from './DirectorHoverCard.module.scss';
import user from '../../../../../../assets/user.png';
import { toTitleCase } from '../../../../../../utils/utils';
import { formatShareholdingPercent } from '../../../../../../utils/formatShareholdingPercent';

/** What the host row knows about a person even when the management-profile roster has no match. */
export interface DirectorHoverUnmatched {
    name?: string;
    designation?: string;
    shareholdingPercentage?: number | null;
}

/**
 * The hover card for a director who is NOT in Management Profile.
 *
 * Every surface showing this card joins its rows to the management-profile roster, and that join can
 * legitimately miss — a person can appear as a related party, an AML/PEP hit or a bureau row without
 * ever having a management profile. Rendering nothing there reads as a broken hover, so the card
 * still opens with what the ROW itself knows (name, designation, shareholding) and says plainly that
 * the profile data is absent, rather than showing empty Tenure/LinkedIn/Directorships rows that
 * would imply the person has none.
 */
function DirectorHoverCardEmpty({ name, designation, shareholdingPercentage }: DirectorHoverUnmatched) {
    const detail = [designation, formatShareholdingPercent(shareholdingPercentage, { hideWhenNull: true })].filter(Boolean).join(' • ');

    return (
        <div className={styles.DirectorHoverCardEmpty}>
            <div className={styles.Header}>
                <img className={styles.Photo} src={user} alt={name ?? ''} />
                <div className={styles.HeaderText}>
                    <div className={styles.Name}>{toTitleCase(name ?? '') || '-'}</div>
                    {detail && <div className={styles.EmptyDetail}>{`• ${detail}`}</div>}
                </div>
            </div>
            <div className={styles.EmptyMessage}>No data available</div>
        </div>
    );
}

export default DirectorHoverCardEmpty;
